"use client"

import { useInfiniteQuery } from "@tanstack/react-query"
import {
  UNIFIED_FEED_QUERY_KEY,
  type UnifiedFeedTypeFilter,
  fetchUnifiedFeed,
} from "./unifiedFeedAPI"

export { UNIFIED_FEED_QUERY_KEY }

export interface UseUnifiedFeedOptions {
  accountId?: string | null
  enabled?: boolean
  type?: UnifiedFeedTypeFilter
  refetchInterval?: number | false | (() => number | false)
  refetchOnMount?: boolean | "always"
}

export function useUnifiedFeed(options?: UseUnifiedFeedOptions) {
  const typeFilter = options?.type ?? "all"

  return useInfiniteQuery({
    queryKey: [UNIFIED_FEED_QUERY_KEY, options?.accountId ?? null, typeFilter],
    queryFn: ({ pageParam }) =>
      fetchUnifiedFeed({
        type: typeFilter,
        cursor: pageParam,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.hasMore ? lastPage.pagination.cursor : undefined,
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
    retry: 1,
    refetchInterval: options?.refetchInterval,
    refetchOnMount: options?.refetchOnMount ?? true,
    refetchOnWindowFocus: true,
  })
}
